// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Grid$Mui from "rescript-material-ui/src/Grid.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../../../../../common/components/icons/App_Icon.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../../../theme/Theme_Colors.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../../../common/App_Typography.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Messages_ModelVersion$DvmAdminFrontendFr from "../../../../../../intl/messages/modelVersion/Messages_ModelVersion.bs.js";
import * as App_TextFieldFormInput$DvmAdminFrontendFr from "../../../../../../common/components/input/App_TextFieldFormInput.bs.js";
import * as App_AutocompleteFormInput$DvmAdminFrontendFr from "../../../../../../common/components/input/App_AutocompleteFormInput.bs.js";

function Order_Detail_Bonus_DealerRequest_Document_Row(Props) {
  var setNewDocuments = Props.setNewDocuments;
  var index = Props.index;
  var item = Props.item;
  var documentTypes = Props.documentTypes;
  return React.createElement(Core.Grid, {
              alignItems: "center",
              children: null,
              container: true,
              item: true,
              justifyContent: "space-between",
              spacing: 2,
              key: String(index)
            }, React.createElement(Core.Grid, {
                  children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                        style: {
                          wordBreak: "break-all"
                        },
                        children: item.document.name,
                        variant: "body"
                      }),
                  item: true,
                  xs: Grid$Mui.Xs[3]
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                        label: Messages_ModelVersion$DvmAdminFrontendFr._type,
                        value: {
                          TAG: /* Single */0,
                          _0: {
                            value: item.fileType,
                            onChange: (function (val) {
                                Curry._1(setNewDocuments, (function (documents) {
                                        return Belt_List.mapWithIndex(documents, (function (indexDoc, doc) {
                                                      if (indexDoc === index) {
                                                        return {
                                                                document: doc.document,
                                                                fileType: val,
                                                                comment: doc.comment,
                                                                uploaded: doc.uploaded
                                                              };
                                                      } else {
                                                        return doc;
                                                      }
                                                    }));
                                      }));
                              })
                          }
                        },
                        options: {
                          TAG: /* Labeled */1,
                          _0: Belt_List.map(Belt_List.sort(App_Types_Result$DvmAdminFrontendFr.getWithDefault(documentTypes, /* [] */0), (function (a, b) {
                                      return (
                                              a.mandatory ? 0 : 1
                                            ) - (
                                              b.mandatory ? 0 : 1
                                            ) | 0;
                                    })), (function (x) {
                                  return {
                                          label: {
                                            TAG: /* String */3,
                                            _0: x.fileLabel
                                          },
                                          value: x.fileType
                                        };
                                }))
                        },
                        fullWidth: true
                      }),
                  item: true,
                  xs: Grid$Mui.Xs[3]
                }), React.createElement(Core.Grid, {
                  children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, {
                        onChange: (function (val) {
                            Curry._1(setNewDocuments, (function (documents) {
                                    return Belt_List.mapWithIndex(documents, (function (indexDoc, doc) {
                                                  if (indexDoc === index) {
                                                    return {
                                                            document: doc.document,
                                                            fileType: doc.fileType,
                                                            comment: val,
                                                            uploaded: doc.uploaded
                                                          };
                                                  } else {
                                                    return doc;
                                                  }
                                                }));
                                  }));
                          }),
                        value: item.comment,
                        fullWidth: true,
                        label: Messages_Common$DvmAdminFrontendFr.comment
                      }),
                  item: true,
                  xs: Grid$Mui.Xs[5]
                }), React.createElement(Core.Grid, {
                  children: React.createElement(Core.IconButton, {
                        onClick: (function (param) {
                            Curry._1(setNewDocuments, (function (documents) {
                                    return Belt_List.keepWithIndex(documents, (function (param, ind) {
                                                  return ind !== index;
                                                }));
                                  }));
                          }),
                        children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                              size: /* Large */3,
                              type_: /* Trash */38,
                              color: Theme_Colors$DvmAdminFrontendFr.accentRed
                            })
                      }),
                  item: true,
                  xs: Grid$Mui.Xs[1]
                }));
}

var make = Order_Detail_Bonus_DealerRequest_Document_Row;

export {
  make ,
}
/* react Not a pure module */
